import { keyframes } from '@emotion/css'
import styled from '@emotion/styled'

import { calcRem } from 'component-library/__styling/style-functions'
import { colors } from 'component-library/__styling/settings'
import { withClass } from 'common/emotion'

const progress = keyframes({
    '0%': {
        backgroundPosition: `-${calcRem(400)} 0`,
    },
    '100%': {
        backgroundPosition: `calc(${calcRem(400)} + 100%) 0`,
    },
})

const color = colors.perthnow.greyGlass
const highlight = colors.perthnow.greyPyrite
const darkColour = colors.perthnow.greyBasalt90
const darkHighlight = colors.perthnow.greyFlint

let skeletonGradientDisabled = false

export const disableSkeletonGradient = () => {
    skeletonGradientDisabled = true
}

export interface StyledSkeletonProps {
    dark?: boolean
    round?: boolean
    height?: number
}

export const StyledSkeleton = withClass('skeleton')(
    styled('span')<StyledSkeletonProps>(
        {
            animation: `${progress} 1.8s ease-in-out infinite`,
            backgroundSize: '400px 100%',
            backgroundRepeat: 'no-repeat',
            borderRadius: '2px',
            display: 'inline-block',
            lineHeight: 0.9,
            margin: `${calcRem(3)} 0`,
            width: '100%',
        },
        props => {
            const skeletonColour = props.dark ? darkColour : color
            const skeletonHighlight = props.dark ? darkHighlight : highlight

            return {
                height: props.height ? `${calcRem(props.height)}` : 'auto',
                borderRadius: props.round ? '100%' : 0,
                backgroundColor: skeletonColour,
                backgroundImage: skeletonGradientDisabled
                    ? `none`
                    : `linear-gradient(90deg, ${skeletonColour}, ${skeletonHighlight}, ${skeletonColour})`,
            }
        }
    )
)
